const messages: Record<string, string> = {
  fx_invalid_workbook:
    "The workbook is invalid. Check the Finance layout, currency codes and positive numeric rates. No rates were imported.",
  fx_invalid_configuration:
    "Check the source, fiscal period, validity dates and authorization reason. No rates were imported.",
  fx_upload_too_large: "The workbook exceeds the 25 MB upload limit.",
  fx_workbook_limit: "The workbook exceeds the permitted archive or row limits.",
  fx_preview_expired: "This preview has expired. Edit the configuration and create a fresh preview before importing.",
  fx_preview_conflict: "Rates or the valuation context changed after review. Create a fresh preview before importing.",
  fx_preview_blocked: "Resolve the preview validation blockers before importing.",
  fx_preview_not_found: "This preview is no longer available. Create a fresh preview.",
  fx_reference_not_found: "The approved reference rate is no longer available. Select another current rate.",
};
export const rateErrorMessage = (error: unknown) => {
  const detail = (error as { data?: { detail?: { code?: string; message?: unknown } } })?.data?.detail;
  const code = detail?.code;
  const baseMessage =
    (code && messages[code]) ||
    "The request could not complete. Try again; retrying an applied preview retrieves its existing result safely.";
  // These domain codes carry bounded parser diagnostics, never unrestricted server errors.
  if (
    (code === "fx_invalid_workbook" || code === "fx_workbook_limit") &&
    typeof detail?.message === "string" &&
    detail.message.length <= 256
  ) {
    return `${baseMessage} ${detail.message}`.trimEnd();
  }
  return baseMessage;
};
